import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Color } from '../../../../server-types';
import { Typography } from '../../../../ui-kit';
import { CategoryColorMarker, ColoredClickableTypography, SubCategoryColorMarker } from './style';

interface CategoryTitleProps {
    color?: Color;
    onClick: () => void;
    name: string;
    productCount: number;
    child?: boolean;
}

interface CategoryNameProps {
    color: Color;
    onClick: () => void;
    name: string;
    child?: boolean;
}

const CategoryName: React.FC<CategoryNameProps> = ({ color, name, child, onClick }) => (
    <Box display='flex' alignItems='center'>
        {child ? <SubCategoryColorMarker color={color} /> : <CategoryColorMarker color={color} />}
        <Box mr={2} />
        <ColoredClickableTypography
            textColor={color}
            variant={child ? 'subtitle2' : 'h6'}
            onClick={onClick}
        >
            {name}
        </ColoredClickableTypography>
    </Box>
);

const CategoryTitle: React.FC<CategoryTitleProps> = ({ color, onClick, name, productCount, child }) => {
    const { t } = useTranslation();
    const productCountText = child
        ? t('{{count}} product', { count: productCount })
        : t('{{count}} product in total', { count: productCount });
    return (
        <Box
            display='flex'
            flex={1}
            justifyContent='space-between'
            alignItems='center'
        >
            {color
                ? (
                    <CategoryName
                        name={name}
                        onClick={onClick}
                        color={color}
                        child={child}
                    />
                )
                : (
                    <Typography
                        variant={child ? 'subtitle2' : 'h6'}
                        onClick={onClick}
                    >
                        {name}
                    </Typography>
                )}
            <Typography uppercase variant='subtitle2'>{productCountText}</Typography>
        </Box>
    );
};

export default CategoryTitle;
